import { Accordion, AccordionSize, Heading } from '@atlassian/learning-components';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { media } from '@atlaskit/primitives/responsive';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import { ContentfulIltFaqSection, ContentfulIltFaqItem } from 'src/graphql/queries/GetInstructorLedTraining';

interface FaqSectionProps {
  faqData?: ContentfulIltFaqSection;
}

export const FaqSection = ({ faqData }: FaqSectionProps) => {
  if (!faqData || !faqData.faqItemsCollection?.items || faqData.faqItemsCollection.items.length === 0) {
    return null;
  }

  const tabsContent = faqData.faqItemsCollection.items.map((item: ContentfulIltFaqItem) => ({
    title: item?.question || '',
    children: <FaqAnswer answer={item?.answer} />,
    isExpanded: false,
  }));

  return (
    <section css={faqContainerStyles}>
      <div css={faqContentStyles}>
        <Heading level={4}>{faqData.title}</Heading>
        <Accordion
          tabsContent={tabsContent}
          size={AccordionSize.FULL_WIDTH}
          shouldSingleTabBeOpen={true}
          onChange={() => {}}
        />
      </div>
    </section>
  );
};

interface FaqAnswerProps {
  answer?: ContentfulIltFaqItem['answer'];
}

const FaqAnswer = ({ answer }: FaqAnswerProps) => {
  const answerJson = answer?.__typename === 'MlLayoutContent' ? answer.content?.json : null;

  if (!answerJson) {
    return null;
  }

  return <>{documentToReactComponents(answerJson)}</>;
};

const faqContainerStyles = css({
  display: 'flex',
  justifyContent: 'center',
  backgroundColor: '#F8F8F8',
  // Break out of parent container
  width: '100vw',
  position: 'relative',
  left: '50%',
  right: '50%',
  marginLeft: '-50vw',
  marginRight: '-50vw',
  padding: `${token('space.600')} ${token('space.400')}`,

  [media.below.sm]: {
    padding: `${token('space.600')} ${token('space.300')}`,
  },
});

const faqContentStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: token('space.400'),
  maxWidth: '1200px',
  width: '100%',
});
